import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "text-secondary border-secondary border-b pb-2 text-xs font-bold" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-2 sm:grid-cols-3" }
const _hoisted_4 = { class: "flex flex-col gap-2" }
const _hoisted_5 = { class: "relative flex items-center gap-2" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = { class: "relative flex items-center gap-2" }
const _hoisted_8 = { class: "flex flex-col gap-2" }

import { useI18n } from 'vue-i18n';
    import { Label } from '@/components/ui/label';
    import { Input } from '@/components/ui/input';
    import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeChangesGroupField',
  props: {
    name: {},
    data: {},
    oldValue: {},
    realValue: {},
    updateValue: {},
    employee: {},
    group: {},
    groupKey: {},
    translation: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const noChangesRegistered = (v: string | number | undefined) => v === 'no_change';

    const old = computed(() => {
        return props.oldValue ?? props.data?.old?.[props.name]?.value ?? null;
    });

    const real = computed(() => {
        return (
            props.realValue ??
            props.employee?.[props.groupKey]?.[props.name] ??
            props.employee?.[props.name] ??
            null
        );
    });

    const oldVal = computed(() => {
        if (old.value === null || old.value === '') return 'no_change';
        return old.value != real.value ? old.value : 'no_change';
    });

    const realVal = computed(() => {
        if (real.value === 0 || real.value === '0' || real.value === null || real.value === '')
            return '-';
        return real.value;
    });

    const dateVal = computed(() => {
        if (old.value === null || old.value === '' || old.value === real.value) return 'no_change';
        const updatedAt =
            props.updateValue ?? props.data?.attributes?.[props.name]?.updated_at ?? null;
        return updatedAt === null || updatedAt === '' ? 'no_change' : updatedAt;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.translation ?? _unref(t)(`employee.${_ctx.groupKey}.${_ctx.name}`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Label), { class: "text-muted-foreground" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('forms.from')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Input), {
            "model-value": 
                            noChangesRegistered(oldVal.value)
                                ? _unref(t)('employee.changes.no_changes_registered')
                                : oldVal.value
                        ,
            class: _normalizeClass(noChangesRegistered(oldVal.value) ? 'text-faded-foreground' : ''),
            disabled: true
          }, null, 8, ["model-value", "class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Label), { class: "text-muted-foreground" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('forms.to')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(Input), {
            "model-value": 
                            noChangesRegistered(realVal.value)
                                ? _unref(t)('employee.changes.no_changes_registered')
                                : realVal.value
                        ,
            class: _normalizeClass(noChangesRegistered(realVal.value) ? 'text-faded-foreground' : ''),
            disabled: true
          }, null, 8, ["model-value", "class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Label), { class: "text-muted-foreground" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('employee.changes.change_date')), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Input), {
          "model-value": 
                        noChangesRegistered(dateVal.value)
                            ? _unref(t)('employee.changes.no_changes_registered')
                            : dateVal.value
                    ,
          class: _normalizeClass(noChangesRegistered(dateVal.value) ? 'text-faded-foreground' : ''),
          disabled: true
        }, null, 8, ["model-value", "class"])
      ])
    ])
  ]))
}
}

})